import React from 'react'
import './App.css'
import Home from './PortfolioContainer/Home/Home'
import {
  BrowserRouter as Router,
  Route,
  Routes,

} from 'react-router-dom'
import Navbar from './Components/Navbar'
import AboutMe from './PortfolioContainer/AboutMe/About'
import Articles from './PortfolioContainer/Home/Articles/Articles'
import Projects from './PortfolioContainer/Projects/Projects'
import Footer from './Components/Footer'

const App = () => {
  return (
    <>
      <Router className="App">
        <Navbar />
        <Routes>
          <Route path='/' element={<Home />}>

          </Route>
          <Route path='/about' element={<AboutMe />}>

          </Route>
          <Route path='/article' element={<Articles />}>

          </Route>
          <Route path='/project' element={<Projects />}>

          </Route>

        </Routes>
      </Router>
      <Footer />
    </>
  );
}

export default App;
